(() => {
  const allowed = new Set(['routine_started', 'routine_step_completed', 'routine_results_ready', 'routine_cart_added', 'routine_left']);
  const fields = new Set(['step', 'product_count']);
  window.DodoMetrics = {
    publish(name, input = {}) {
      try {
        const shopify = window.Shopify;
        if (!allowed.has(name) || shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true || shopify.customerPrivacy.currentVisitorConsent().analytics !== 'yes' || !shopify?.analytics?.publish) return false;
        const data = {version: 1};
        for (const [key, value] of Object.entries(input)) {
          if (fields.has(key) && Number.isInteger(value) && value >= 0 && value <= 20) data[key] = value;
        }
        const result = shopify.analytics.publish(`dodo:${name}`, data);
        if (result?.catch) result.catch(() => {});
        return true;
      } catch (_) { return false; }
    }
  };
})();
